import { DataHeader } from '@acin/ui-core';

export const TABLE_HEADERS: DataHeader[] = [
  { label: 'Client', key: 'clientCode', width: '20%', sortable: false },
  { label: 'Regulation', key: 'regulationName', width: '20%', sortable: false },
  { label: 'Document', key: 'documentName', width: '20%', sortable: false },
  { label: 'Created', key: 'createdAt', minWidth: '20%', sortable: false },
  { label: 'Published', key: 'publishedAt', minWidth: '20%', sortable: false },
  { label: 'Status', key: 'status', minWidth: '20%', sortable: false },
];
